import { createStyles, Text } from '@mantine/core';
import React from 'react';

export const useEyebrowStyles = createStyles((theme) => ({
  eyebrow: {
    position: 'absolute',
    top: 0,
    left: '50%',
    padding: '4px 10px',
    transform: 'translate(-50%, -50%)',
    background: 'white',
    border: `1px solid ${theme.colors.secondary[theme.primaryShade as any]}`,
    borderRadius: '999em',
    lineHeight: 1,
  },
}));

export type EyebrowProps = {
  text: any;
  [key: string]: any;
};

const Eyebrow = ({ text, ...rest }: EyebrowProps) => {
  const { classes } = useEyebrowStyles();

  return (
    <Text
      tt="uppercase"
      weight={700}
      align="center"
      size="xs"
      color="primary"
      className={`${classes.eyebrow} ${rest.className || ''}`}
      {...rest}
    >
      {text}
    </Text>
  );
};

export default Eyebrow;
